import { useEffect, useState, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import "@/components/components.css";
import "@/pages/ultimate-lap.css";
import "@/theme-duotone.css";
import Landing from "./pages/Landing";
import Loader from "./components/Loader";
import ScrollToTop from "./components/ScrollToTop";
import PageTitle from "./components/PageTitle";
import DownloadOverlay from "./components/DownloadOverlay";

// Route-level code splitting — landing loads immediately; secondary routes lazy.
const UltimateLap = lazy(() => import("./pages/UltimateLap"));
const EnterRound = lazy(() => import("./pages/EnterRound"));
const Leaderboard = lazy(() => import("./pages/Leaderboard"));
const Results = lazy(() => import("./pages/Results"));
const ComingSoon = lazy(() => import("./pages/ComingSoon"));
const Admin = lazy(() => import("./pages/admin/Admin"));
const EventMicrosite = lazy(() => import("./pages/EventMicrosite"));
const Contact = lazy(() => import("./pages/Contact"));
const About = lazy(() => import("./pages/About"));

function RouteFallback() {
  return <div style={{ minHeight: "100svh", background: "#000" }} />;
}

function ScrollingApp() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <PageTitle />
      <DownloadOverlay />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/events/ultimate-lap" element={<UltimateLap />} />
          <Route path="/events/ultimate-lap/results" element={<Results />} />
          <Route path="/events/ultimate-lap/enter" element={<EnterRound />} />
          {/* :round is a number, or "season" for the season pass (client, 2026-09-17). */}
          <Route path="/events/ultimate-lap/enter/:round" element={<EnterRound />} />
          <Route path="/events/ultimate-lap/enter/:round/confirmed" element={<EnterRound />} />
          {/* Private link for season-pass holders to complete their details (client, 2026-10-19). */}
          <Route path="/season-pass/complete" element={<EnterRound holder />} />
          <Route path="/events/:slug" element={<EventMicrosite />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/*" element={<Admin />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<ComingSoon title="404 off track" kind="page" />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default function App() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    // Safety net: reveal the app even if the loader never reports done. Sits
    // past the loader's own caps (20s media / 12.5s film) so the loader, not
    // this timer, decides when the site is ready (client, 2026-10-21).
    const t = setTimeout(() => setReady(true), 24000);
    return () => clearTimeout(t);
  }, []);
  return (
    <>
      <Loader onDone={() => setReady(true)} />
      <div style={{ visibility: ready ? "visible" : "hidden" }}>
        <ScrollingApp />
      </div>
    </>
  );
}
